/// <amd-module name="Artifacts/Root/helpers/PackageDecoderHelper" />
import { Protocol } from "../Constants";

/* 
  These functions are used to encode and decode the illegal characters within the URL that are blocked by IIS.
  Since we use the display names/versions of packages in the URL, we need to encode the special characters so
  the values can be used. We then decode the values to send requests to the backend.

  Revise these functions when new protocols are added.
*/

// replace only changes the first occurance.
// We may need to iterate and create a new string.
export function decodeName(name: string, protocol: string): string {
  if (protocol.toLocaleLowerCase() === Protocol.Maven.toLocaleLowerCase()) {
    return decodeURIComponent(name).replace("/", ":");
  }
  return decodeURIComponent(name);
}

// We need to encode this for all operation where Feed calls Packaging API directly with package name
// U+1F4E6 is the package emoji
// "encodeNameOrVersionForPackagingUriPath(1+2📦3:4/5.6\7) = 1=002b2=d83d=dce63=003a4=002f5.6=005c7"
export function encodeNameOrVersionForPackagingUriPath(name: string): string {
  return name.replace(/[^-_.a-zA-Z0-9]/gu, (x) =>
    x
      .split("")
      .map((y) => "=" + pad4Hex(y.charCodeAt(0)))
      .join(""),
  );
}

function pad4Hex(num: number): string {
  const str = num.toString(16);
  switch (str.length) {
    case 1:
      return "000" + str;
    case 2:
      return "00" + str;
    case 3:
      return "0" + str;
    case 4:
      return str;
  }
  throw new Error("Unexpected length of character in package name");
}

export function encodeName(name: string, protocol: string): string {
  if (protocol.toLocaleLowerCase() === Protocol.Maven.toLocaleLowerCase()) {
    return name.replace(":", "/");
  }
  return name;
}

export function encodeVersion(version: string, protocol: string): string {
  return version.replace("+", " ");
}

export function decodeVersion(version: string, protocol: string): string {
  return decodeURIComponent(version).replace(" ", "+");
}
